import sileo from 'sileo';
import axios from 'source/lib/axios';
import plex from 'core/js/restmodel';


const OnboardingApplicant = new sileo.Model(
    'hqzen', 'onboarding-applicant');
const ValidateContactDetails = new sileo.Model(
    'hqzen', 'validate-applicant');
const ApplicantVerificationCode = new sileo.Model(
    'hqzen', 'verify-onboarded-applicant');
const ApplicantEmail = new sileo.Model(
    'hqzen', 'applicant-email');
const ApplicantPreferredSalary = new sileo.Model(
    'hqzen', 'applicant-preferred-salary');
const Location = new sileo.Model(
    'hqzen', 'locations');
const ApplicantPreferredWorkLocation = new sileo.Model(
    'hqzen', 'applicant-preferred-work-location');
const OnboardingEmployer = new sileo.Model(
    'hqzen', 'onboarding-employer');
const EmployerVerificationCode = new sileo.Model(
    'hqzen', 'verify-onboarded-employer');
const EmployerEmail = new sileo.Model(
    'hqzen', 'employer-email');
const ApplicantResume = new sileo.Model(
    'hqzen', 'onboarding-applicant-resume');
const AWSResume = new sileo.Model(
    'hqzen', 'onboarding-applicant-aws-details');
const AWSVideo = new sileo.Model(
    'hqzen', 'pre-interview-video');
const BusinessSignUp = new sileo.Model(
    'hqzen', 'business-sign-up');
const SetupApplicant = new sileo.Model(
    'hqzen', 'setup-applicant');
const SetupChangePassword = new sileo.Model(
    'hqzen', 'update-user-password');
const JobApplicationDocument = new sileo.Model(
    'hqzen', 'job-application-document-upload');
const addOrgExecsAsWfExecs = new sileo.Model(
    'hqzen', 'add-org-execs-as-wf-execs'
);
const CheckEmail = new sileo.Model(
    'hqzen', 'email-existence'
);
const CheckContactNumber = new sileo.Model('hqzen', 'contact-number-existance');
const CheckCompanyName = new sileo.Model('hqzen', 'company-name-existance')
const BusinessUserInfo = new sileo.Model('hqzen', 'business-user-info');

const state = {
    eligibleLocations: [],
};

const getters = {
    eligibleLocations: state => state.eligibleLocations,
};

const mutations = {
    setLocations(state, locations) {
        state.eligibleLocations = locations;
    },

    setToken(state, token) {
        if (token.token) {
            axios.defaults.headers.common['Authorization'] = token.token;
            sileo.defaults.headers['Authorization'] = token.token;
            plex.defaults.headers['Authorization'] = token.token;

            axios.defaults.headers.common['X-Refresh-Token'] = token.refresh;
            sileo.defaults.headers['X-Refresh-Token'] = token.refresh;
            plex.defaults.headers['X-Refresh-Token'] = token.refresh;
            localStorage.setItem('auth_token', token.token);
            localStorage.setItem('refresh_token', token.refresh);
        }
    }
};

const actions = {
    createApplicantUser(context, data) {
        const form = new FormData();
        form.append('email', data.email);
        form.append('first_name', data.first_name);
        form.append('middle_name', data.middle_name);
        form.append('last_name', data.last_name);
        form.append('password', data.password);
        form.append('country_code', data.country_code);
        form.append('region', data.region);

        if (data.phone_country_code & data.phone_number) {
            form.append('phone_country_code', data.phone_country_code);
            form.append('phone_number', data.phone_number);
        }

        return OnboardingApplicant.objects.create(form);
    },

    validateUserContactDetails(context, filters) {
        return ValidateContactDetails.objects.filter(filters);
    },

    sendVerificationCode(context, { data, filters }) {
        const form = new FormData();
        form.append('username', data.username);
        form.append('password', data.password);

        return ApplicantVerificationCode.objects
            .update(filters, form);
    },

    uploadRequirement(context, data) {
        const form = new FormData();

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return ApplicantResume.objects.create(form);
    },

    async fetchResumeAmazon(context, file_type) {
        return await AWSResume.objects.filter({ file_type: file_type }).then(amazon => {
            return amazon.amazon;
        });
    },

    async fetchVideoAmazon(context, file_type) {
        return await AWSVideo.objects.filter({ file_type: file_type }).then(amazon => {
            return amazon.amazon;
        });
    },

    updateEmail(context, { data, filters }) {
        const form = new FormData();
        form.append('email', data.email);

        return ApplicantEmail.objects.update(filters, form);
    },

    updateApplicantPreferredSalary(context, { data, filters }) {
        const form = new FormData();
        form.append('currency', data.currency);
        form.append('salary_expectation', data.salary_expectation);

        return ApplicantPreferredSalary.objects
            .update(filters, form);
    },

    fetchLocations(context) {
        Location.objects.filter()
            .then(response => {
                context.commit('setLocations', response);
            });
    },

    updateApplicantPreferredWorkLocation(context, { data, filters }) {
        const form = new FormData();
        form.append('job_locations', data.job_locations);

        return ApplicantPreferredWorkLocation.objects
            .update(filters, form);
    },

    createEmployerUser(context, data) {
        const form = new FormData();
        form.append('email', data.email);
        form.append('first_name', data.first_name);
        form.append('last_name', data.last_name);
        form.append('company_name', data.company_name);
        form.append('phone_country_code', data.country.phone_country_code);
        form.append('phone_number', data.phone_number);
        form.append('password', data.password.value);

        return OnboardingEmployer.objects.create(form);
    },

    sendEmployerVerificationCode(context, { data, filters }) {
        const form = new FormData();

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return EmployerVerificationCode.objects
            .update(filters, form);
    },

    updateEmployerEmail(context, { data, filters }) {
        const form = new FormData();
        form.append('email', data.email);

        return EmployerEmail.objects.update(filters, form);
    },

    createBusinessSignUp(context, data) {
        const form = new FormData();
        form.append('email', data.email);
        form.append('first_name', data.first_name);
        form.append('last_name', data.last_name);
        form.append('company_name', data.company_name);
        form.append('phone_country_code', data.phone_country_code);
        form.append('phone_number', data.phone_number);
        form.append('password', data.password);
        form.append('region', data.region);

        return BusinessSignUp.objects.create(form);
    },

    setUpApplicantsAccount(context, data) {
        return SetupApplicant.objects.create(data);
    },

    changeUserPassword({ commit }, data) {
        const filter = {};
        return SetupChangePassword.objects.update(filter,data).then(response => {
            commit('setToken', { 'token': response.auth_token.new_access_token,
            'refresh': response.auth_token.new_refresh_token });
            return response;
        }).catch(error => {
            return JSON.parse(error.response).data;
        });
    },

    uploadResumeApplication(context, data) {
        const formData = new FormData();

        for (let [key, value] of Object.entries(data)) {
            formData.append(key, value);
        }

        return JobApplicationDocument.objects.create(formData);
    },

    addOrgExecs({ commit }, data) {
        return addOrgExecsAsWfExecs.objects.update({ 'workforce_id': data });
    },

    CheckExistingEmail(context, filters) {
        return CheckEmail.objects.filter(filters);
    },

    CheckExistingContactNumber(context, filters) {
        return CheckContactNumber.objects.filter(filters);
    },

    CheckExistingCompanyName(context, filters) {
        return CheckCompanyName.objects.filter(filters);
    },

    createBusinessUserInfo(context, data) {
        const formData = new FormData();

        for (let [key, value] of Object.entries(data)) {
            if (value !== null && typeof value === 'object') {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        }

        return BusinessUserInfo.objects.create(formData);
    }

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
